/**
 * Strategy for quering orders with interval.
 */
export enum DateStrategy {
  /**
   * Selects the business date if one exists, otherwise creation date.
   */
  BusinessDateFirst = 'businessDateFirst',

  /**
   * Only selects the business date.
   */
  BusinessDateOnly = 'businessDateOnly',

  /**
   * Only selects the creation date.
   */
  DateOnly = 'dateOnly'
}